import { TextAreaProps as RadixTextAreaProps } from '@radix-ui/themes';

export type TextAreaSize = '1' | '2' | '3';

export type TextAreaProps = Omit<
  RadixTextAreaProps,
  'size' | 'color' | 'radius'
> & {
  size?: TextAreaSize;
  label?: React.ReactNode;
  error?: boolean;
  errorMessage?: React.ReactNode;
  withTooltip?: boolean;
  tooltip?: React.ReactNode;
};

export const sizeToFontSize: Record<TextAreaSize, string> = {
  '1': 'text-size-fly-1',
  '2': 'text-size-fly-2',
  '3': 'text-size-fly-3',
};

export const sizeToClassName: Record<TextAreaSize, string> = {
  '1': 'rounded-4',
  '2': 'rounded-5',
  '3': 'rounded-5',
};
